import axios from 'axios';
import { getApiBaseUrl, getVimeoAPI } from 'helpers/api';
import axiosInstance from 'utils/axiosInstance';

const baseUrl = getApiBaseUrl();
export const VIMEO_BASE_URL = getVimeoAPI();

export const getLastNotificationBySectionApi = ({
  section,
}: {
  section: string;
}) => {
  return axiosInstance.get('/getNotificationBySection', {
    params: { type: section },
  });
};

export const getAllNotifications = () => {
  return axiosInstance.get('/notifications');
};

export const setNotificationReadApi = ({ id }: { id: number }) => {
  return axiosInstance.get('/setNotificationRead', {
    params: { id },
  });
};

export const getVimeoThumbnailSrcApi = (videoId: string) =>
  axios.get(`${VIMEO_BASE_URL}${videoId}.json`);

export function getFaqApi(data: { lang: string }) {
  return axios.get(`${baseUrl}/faq?language=${data.lang}`);
}

export function getContactsApi(lang: string) {
  return axios.get(`${baseUrl}/contacts?language=${lang}`);
}

export function reportBugApi(data: any) {
  return axiosInstance.post(`/user/settings/submitBug`, data);
}

export const getLocalisations = ({
  type,
  curentPosition,
}: {
  type: string;
  curentPosition: {
    lat?: number;
    lng?: number;
  };
}) => {
  return axios.post(`${baseUrl}/user/filter_geoloc`, {
    type: type.split(','),
    curentPosition,
  });
};
